export const LastInteractionDate = ({ props }) => ([
  { text: 'Anfrage', value: 'request_date:!=null' },
  { text: 'Gelesen', value: 'read_date:!=null' },
  { text: 'Ungelesen', value: 'read_date:::null' },
  { text: 'Erinnerung', value: `reminder_date:!=null` },
  { text: 'Beantwortet', value: `answer_date:!=null` },
  { text: 'Nicht beantwortet', value: 'answer_date:::null' },
  { text: 'Nicht angefordert', value: 'id:::null' },
  { text: props.settings?.poolRequestConfirmationOfReceipt ? 'Bestätigt' : 'Formal korrekt', value: 'submit_date:!=null' },
  { text: 'Nicht bestätigt', value: 'submit_date:::null' },
])
